<template>
  <div class="contMain">

    <div class="leftSection">
      <div class="contCheckboxMain">
        <div class="contCheckboxCtrlMain">
          <div class="contCheckboxCtrl" :style="{ 'cursor' : (data['mode'] == 'V' ? 'normal' : 'pointer') }" @click="checkBoxClk('opt1')"></div>
          <CheckBox class="contCheckbox" :isChecked="data['Option'] == '1'" title="Select from list of containers belonging to a job"
            :isDisabled="data['mode'] == 'V'"/>
        </div>
        <div class="contCheckboxCtrlMain">
          <div class="contCheckboxCtrl" :style="{ 'cursor' : (data['mode'] == 'V' ? 'normal' : 'pointer') }" @click="checkBoxClk('opt0')"></div>
          <CheckBox class="contCheckbox" :isChecked="data['Option'] == '0'" title="Request by total No of Containers"
            :isDisabled="data['mode'] == 'V'"/>
        </div>
      </div>
      <div class="contSelectionBox">
        <div class="tableMain" v-if="data['Option'] == '1'">
          <div class="contTableCtrlMain" v-if="data['mode'] != 'V'">
            <button class="contTableCtrl" @click="btnClick('add')"> + </button>
            <button class="contTableCtrl" @click="btnClick('del')"> - </button>
          </div>
          
          <div class="contTableMain">
            <Tabulator class="contTable" tableTitle="Container List" tableID="contRotTableMain" :tableData="data['rotContROTView']" 
            :selectedRow.sync="contSelected" :multiSelect="data['mode'] == 'V' ? 0 : -1" :hideColumns="tabHideCol"/>
          </div>
        </div>

        <div class="numContMain" v-if="data['Option'] == '0'">
          <Input placeholder="No of Cont Required" :inputValue.sync="data['NoContRequired']" :isDisabled="data['mode'] == 'V'"
              :isRequired="true" :errorMessage.sync="data['rotErrors']['nocontrequired']"/>
          <Dropdown placeholder="Container Size" :items="data['rotContSize']" itemKey="Size" :selectedObject.sync="data['ContSize']"
              :isDisabled="data['mode'] == 'V'" :isRequired="true" :errorMessage.sync="data['rotErrors']['contsize']"/>
          <Dropdown placeholder="Container Type" :items="data['rotContType']" itemKey="desc" :selectedObject.sync="data['ContType']"
              :isDisabled="data['mode'] == 'V'" :isRequired="true" :errorMessage.sync="data['rotErrors']['conttype']"/>
          <Dropdown placeholder="Handling" :items="data['rotContHdg']" itemKey="desc" :selectedObject.sync="data['Handling']"
              :isDisabled="data['mode'] == 'V'" :isRequired="true" :errorMessage.sync="data['rotErrors']['handling']"/>
          <Dropdown placeholder="Delivery" :items="data['rotContDel']" itemKey="desc" :selectedObject.sync="data['Delivery']"
              :isDisabled="data['mode'] == 'V'" :isRequired="true" :errorMessage.sync="data['rotErrors']['delivery']"/>
        </div>
      </div>
    </div>

    <div class="rightSection">
      <Input class="rightInputs" placeholder="Temperature" :inputValue.sync="data['Temperature']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="M3" :inputValue.sync="data['M3']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="Weight (KG)" :inputValue.sync="data['Weight']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="Height (M)" :inputValue.sync="data['Height']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="Cont. Operator" :inputValue.sync="data['ContOperator']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="Cont. Line" :inputValue.sync="data['ContLine']" :isDisabled="data['mode'] == 'V'"/>
      <Input class="rightInputs" placeholder="Commodity" :inputValue.sync="data['Commodity']" :isRequired="true" :isDisabled="data['mode'] == 'V'"
            :errorMessage.sync="data['rotErrors']['commodity']"/>
      <CheckBox class="rightInputs" :isChecked.sync="data['Fumigation']" title="Fumigation" @checkBoxClicked="null" :isDisabled="data['mode'] == 'V'"/>

      <div class="rightRemarks" :style="{ 'height' : 'auto' }">
        <Remarks class="rightRemarksInput" :text.sync="data['Remarks']" maxLength="300" :isDisabled="data['mode'] == 'V'"/>
        <div class="bootlegQueryMain"> 
          <InputQuery class="bootlegQuery" placeholder="RemarksDropdown" :items="data['rotRemarks']" itemKey="Remarks" descKey="" 
            @selected="remarkChange" :isDisabled="data['mode'] == 'V'"/>
        </div>
      </div>
    </div>

    <div class="popUpMain" v-if="showPopUp">
      <div class="popUpContent">
        <Tabulator class="popUpTable" tableTitle="Add Containers" tableID="popUpTableRotMain" :tableData="data['rotContROT']" 
        :selectedRow.sync="popUpSelected" :hideColumns="tabHideCol"/>
        <div class="popUpCtrlMain">
          <button class="popUpCtrl" @click="btnClick('cancel')"> Cancel </button>
          <button class="popUpCtrl" @click="btnClick('confirm')"> Confirm </button>
        </div>
      </div>
    </div>

    <Loader :isVisible="loadShow" :loadingText="loadText" />

  </div>
</template>




<script>
  /* eslint-disable */
  import Menu from '@/components/Menus.vue';
  import Tabulator from '@/components/Tabulator.vue';
  import EntryPopup from '@/components/EntryPopup.vue';
  import TabView from '@/components/TabView.vue';
  import Input from '@/components/Input.vue';
  import InputQuery from '@/components/InputQuery.vue';
  import DateTime from '@/components/DateTimePicker.vue';
  import Dropdown from '@/components/Dropdown.vue';
  import CheckBox from '@/components/CheckBox.vue';
  import Remarks from '@/components/RemarksBox.vue';
  import Loader from '@/components/Loader.vue';

  export default {
    name: 'cont',
    components: {
      Menu, Tabulator, EntryPopup, Input, InputQuery, DateTime, Dropdown, CheckBox, Remarks, TabView, Loader,
    },
    props: {
      //-------- Main Props
      data: { type: Object, default: function () { return {} } },
      viewMode: { type: Boolean, default: false },

      //-------- Table Props
      tableDisabledText: { type: String, default: '' },
      contSelected: { type: Array, default: function() { return []; }},
      popUpSelected: { type: Array, default: function() { return []; }},
      contItems: { type: Array, default: function() { return [{ 'Status' : 'No data'}]; }},
      showPopUp: { type: Boolean, default: false },
      tabHideCol: { type: Array, default: function() { return ['tag']; }},
      
      //-------- CheckBox Props
      checkOption: { type: String, default: '1' },

      //-------- Load Props
      loadShow: { type: Boolean, default: false },
      loadText: { type: String, default: 'Loading' },
    },
    mounted() {
      this.tableDisabledText = (this.data['mode'] == 'V') ? 'View Mode' : '';
    },
    methods: {
      remarkChange: async function(obj) {
        this.$set(this.data, 'Remarks', obj['Remarks'])
      },
      checkBoxClk: async function(chk) {
        if (this.data['mode'] != 'V') {
         // var response = await this.$alert.questionAlert('Selection change', `Are you sure you want to change selection? Unsaved container data will be erased.`, 'Confirm', 'Cancel', 'warning');
          var response = await this.$showAlert(
              'warning',
              'Selection change', 
              'Are you sure you want to change selection? Unsaved container data will be erased.',
              [{"text" : "Confirm"}, {"text" : "Cancel"}]);

          if (response === "Confirm") {
            var itemSearch = this.data['rotContSize'].filter((c) => { return c['Size'].toString() == '20'; })
            this.$set(this.data, 'ContSize', (itemSearch.length > 0) ? itemSearch[0] : null);
            switch(chk) {
              case 'opt0':
                this.$set(this.data, 'Option', '0');
                this.data["rotContROTView"].forEach((c) => {
                  this.$set(c, 'tag', '');
                  this.data["rotContROT"].push(c);
                });
                this.data["rotContROT"].sort((a, b) => { return a['#'] - b['#'] });
                this.$set(this.data, 'rotContROTView', []);
                break;
              case 'opt1':
                this.$set(this.data, 'Option', '1');
                this.$set(this.data, 'NoContRequired', '');
                // this.$set(this.data, 'ContSize', null);
                this.$set(this.data, 'ContType', null);
                this.$set(this.data, 'ContHdg', null);
                this.$set(this.data, 'ContDel', null);

                // Set ROT Containers to 'Default'
                this.data['rotContROTDetails'].forEach((c) => {
                  var contItem = this.data['rotContROT'].filter((c2) => { return c2['Container #'].trim() == c['Cont No'].trim(); })
                  var contIndex = this.data['rotContROT'].indexOf(contItem[0]);
                  this.data['rotContROTView'].push(this.data['rotContROT'].splice(contIndex, 1)[0]);
                });
                break; 
            }
          }
          // console.log(chk);
        }
        
      },
      btnClick: async function(btn) {
        switch(btn) {
          case 'add':
            this.showPopUp = true;
            break;
          case 'del':
            this.contSelected.forEach((c) => {
              var contIndex = this.data["rotContROTView"].indexOf(c);
              var contItem = this.data["rotContROTView"].splice(contIndex, 1);

              var contDefaults = this.data['rotContROTDetails'].filter((c2) => { return c2['Cont No'].trim() == c['Container #'].trim(); });
              if (contDefaults.length > 0) { this.$set(contItem[0], 'tag', 'D'); }
              this.data["rotContROT"].push(contItem[0]);
              // console.log(this.data['rotContROT'].filter((t) => { return t['tag'] == 'D'}).length); //Getting Number of items with 'D' tag.
            });
            this.data["rotContROT"].sort((a, b) => { return a['#'] - b['#'] });
            break;
          case 'cancel':
            this.showPopUp = false;
            this.popUpSelected = [];
            break;
          case 'confirm':
            this.popUpSelected.forEach((c) => {
              var contIndex = this.data["rotContROT"].indexOf(c);
              var contItem = this.data["rotContROT"].splice(contIndex, 1);
              this.$set(contItem[0], 'tag', (contItem[0]['tag'] ? contItem[0]['tag'] : 'N'));
              this.data["rotContROTView"].push(contItem[0]);
            });
            this.showPopUp = false;
            this.popUpSelected = [];
            break;
        }
      },
    },
    watch: {

    },
  }
</script>

<style lang="scss" scoped>
  @import '@/css/all.scss';

  .contMain {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }

  .leftSection {
    width: auto;
    height: auto;
    min-height: 300px;
    min-width: 50%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .rightSection {
    width: auto;
    height: auto;
    min-height: 300px;
    padding: 0 0 0 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .rightInputs {
    width: 50%;
    height: auto;
  }

  .rightRemarks {
    width: 50%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .rightRemarksInput {
    margin: 0 4px 0 0;
    flex: 1;
  }

  .bootlegQueryMain {
    width: 20px;
    height: 40px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
  }

  .bootlegQuery {
    width: auto;
    height: 100%;
    position: absolute;
    left: -35px;
  }

  .contCheckboxMain {
    width: 100%;
    height: auto;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .contCheckboxCtrlMain {
    width: auto;
    height: 24px;
    position: relative;
  }
  
  .contCheckboxCtrl {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    z-index: 2;
  }

  .contCheckbox {
    width: auto;
    height: 100%;
    margin: 0 8px 0 0;
  }

  .contSelectionBox {
    width: 100%;
    height: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  // Tabulator CSS
  .tableMain {
    width: 100%;
    height: 100%;
    max-height: 300px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .contTableMain {
    width: 100%;
    height: auto;
    position: relative;
    flex: 1;
  }

  .contTable {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 36px;
    left: 0px;
    right: 0px;
  }

  .contTableCtrlMain {
    width: 100%;
    height: 28px;
  }

  .contTableCtrl {
    width: auto;
    height: 100%;
    margin: 0 4px 0 0;
  }

  // Number of Cont CSS
  .numContMain {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  }






  .popUpMain {
    width: auto;
    height: auto;
    padding: 30px 50px;
    position: fixed;
    top: 50px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0003;
    z-index: 255;
  }

  .popUpContent {
    width: 100%;
    height: 100%;
    max-width: 80%;
    max-height: 400px;
    padding: 4px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px #0004;
  }

  .popUpTable {
    width: auto;
    height: auto;
    position: absolute;
    top: 4px;
    bottom: 76px;
    left: 4px;
    right: 4px;
    flex: 1;
  }

  .popUpCtrlMain {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .popUpCtrl {
    width: auto;
    height: 100%;
    margin: 0 0 0 4px;
  }

</style>